import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function Hero() {
  return <header className="relative bg-black text-bone pt-24 pb-32 md:pt-32 md:pb-40 overflow-hidden border-b border-gold-hairline" data-id="element-39">
      {/* Subtle gold background texture/pattern */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A24B 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-40"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center md:text-left" data-id="element-42">
          <div className="inline-flex items-center gap-3 px-4 py-1.5 border border-gold-hairline bg-onyx mb-10 shadow-editorial" data-id="element-43">
            <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" data-id="element-44"></span>
            <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-45">
              The 2026 Home Auction Ultimate Guide
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-semibold leading-[1.1] mb-10 text-bone" data-id="element-46">
            Buy Your First Home for a{' '}
            <span className="text-gold italic font-medium" data-id="element-47">
              Fraction of Retail Price
            </span>{' '}
            Without a 20% Downpayment
          </h1>

          <div className="flex md:block justify-center" data-id="element-48">
            <p className="text-lg md:text-xl lg:text-2xl text-bone-muted font-sans leading-relaxed max-w-3xl mb-14 border-l-[1px] border-gold pl-6 text-left" data-id="element-49">
              Stop waiting for a market crash that never comes and start
              accessing the "Hidden National Inventory" that hedge funds and
              pro-flippers have been gatekeeping for decades.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-6 justify-start" data-id="element-50">
            <Button onClick={e => {
            e.preventDefault();
            document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-51">
              Get The Blueprint Now
            </Button>
            <div className="text-sm text-bone-muted flex items-center gap-2" data-id="element-52">
              <svg className="w-4 h-4 text-gold-soft" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-53">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-54"></path>
              </svg>
              Instant PDF Download
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}